import type { SiteRuntimeBanner } from './types';

const STORAGE_PREFIX = 'imgenhancer:announcement-dismissed:';

function storageKey(banner: SiteRuntimeBanner) {
  const identity = banner.dismissKey ?? banner.message;
  return `${STORAGE_PREFIX}${identity}`;
}

export function isBannerDismissedInSession(banner: SiteRuntimeBanner) {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(storageKey(banner)) === '1';
  } catch {
    return false;
  }
}

export function dismissBannerForSession(banner: SiteRuntimeBanner) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(storageKey(banner), '1');
  } catch {
    // Keep the local dismiss action working even when browser storage is blocked.
  }
}
